/* @flow */
// typecheck: ignore file
import ConfirmDialog from 'components/ConfirmDialog.jsx';
import GroupActions from 'groups/actions/GroupActions';
import Group from 'entities/Group';
import React from 'react';
import ToastActions from 'actions/ToastActions';

type Props = {
  archiveFirst?: ?boolean,
  group: Group,
  onSubmit?: ?Function,
  onActionCompletion: Function,
  onRequestHide?: () => any,
  subText: string,
};

export default class ReuseClassConfirmDialog extends React.Component {
  props: Props;

  onSuccess = (group: Group) => {
    ToastActions.showSuccessToast('New class created with code @' + group.getCode());
    this.props.onActionCompletion(group);
  }

  onError = (error: Object) => {
    ToastActions.showErrorToast(error.message);
  }

  handleReuse = () => {
    const { group } = this.props;
    const orgId = group.getOriginalOrganizationId() || null;

    if (this.props.onSubmit) {
      this.props.onSubmit();
    }

    return GroupActions.reuseGroup(group, orgId).then(
      this.onSuccess,
      this.onError,
    );
  };

  handleArchiveAndReuse = () => {
    const { group } = this.props;
    const orgId = group.getOrganization() ? group.getOrganization().id : null;

    if (this.props.onSubmit) {
      this.props.onSubmit();
    }

    return GroupActions.archiveAndReuseGroup(group, orgId).then(
      this.onSuccess,
      this.onError,
    );
  };

  render() {
    return (
      <ConfirmDialog
        eventScreenName="ReuseClassConfirmDialog"
        group={this.props.group}
        title="Reuse this class code?"
        subtext={this.props.subText}
        actionButtonText="Reuse"
        cancelButtonText="Cancel"
        preConfirmPromise={this.props.archiveFirst ? this.handleArchiveAndReuse : this.handleReuse}
        onRequestHide={this.props.onRequestHide}
      />
    );
  }
}




// WEBPACK FOOTER //
// ./src/groups/components/ReuseClassConfirmDialog.jsx